import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export interface Faq { q: string; a: string; }

interface Props { faqs: Faq[]; title?: string; }

const FaqAccordion = ({ faqs, title = "Frequently Asked Questions" }: Props) => (
  <section className="py-14 md:py-20">
    <div className="container max-w-3xl">
      <div className="text-center mb-10">
        <span className="text-eyebrow text-primary">FAQ</span>
        <h2 className="font-heading text-2xl md:text-3xl font-light mt-2">{title}</h2>
      </div>
      <Accordion type="single" collapsible className="space-y-3">
        {faqs.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            className="border border-border rounded-xl bg-card px-5 data-[state=open]:shadow-md"
          >
            <AccordionTrigger className="text-left font-heading text-base md:text-lg hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed text-sm md:text-base">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FaqAccordion;

export const buildFaqJsonLd = (faqs: Faq[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});